import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Api from '../../services/api';

const generateSlug = (title) => {
    if (!title) return 'quiz';
    return title
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)+/g, '');
};

const formatQuizTime = (seconds) => {
    if (!seconds) return '0 min';
    const m = Math.floor(seconds / 60);
    if (m === 0) return `${seconds} sec`;
    return `${m} min`;
};

const ExploreQuizzes = () => {
    const [quizzes, setQuizzes] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getQuizzes();
    }, []);

    const getQuizzes = async () => {
        setLoading(true);
        try {
            const response = await Api.GetRequest({}, 'quizzes');
            if (response && response.status === 200 && response.quizzes) {
                setQuizzes(response.quizzes);
            }
        } catch (error) {
            console.error("Error fetching quizzes:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {/* Top Banner Section to Match Professional Website Layout */}
            <div className="m-0 shadow" style={{ width: '100vw!important', maxWidth: '100vw!important' }}>
                <div className="row mx-0">
                    <div className="col-lg-12 p-0">
                        <div className="commn_banner_page" style={{ position: 'relative' }}>
                            <img src="/assets/img/header_banner.png" className="page-banner-image" alt="banner" style={{ width: '100%', height: '280px', objectFit: 'cover' }} />
                            <h2 className="mb-0 page-label" style={{ position: 'absolute', textAlign: 'left', top: '50%', transform: 'translateY(-50%)', width: '50%', lineHeight: 'normal', left: '8%', color: '#000000', textTransform: 'uppercase', fontWeight: 'bold', fontSize: '36px' }}>
                                Explore Quizzes
                            </h2>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Container Layout */}
            <section id="trending_causes_main" className="px-2" style={{ marginTop: '50px', marginBottom: '50px' }}>
                <div className="container">
                    <div className="row text-center mb-5">
                        <div className="col-12">
                            <h3 style={{ color: '#000', fontWeight: '600' }}>Participate. Learn. Get Recognized.</h3>
                            <div style={{ width: '60px', height: '3px', background: 'var(--main-color, #198754)', margin: '15px auto 0' }}></div>
                        </div>
                    </div>

                    <div className="row" id="counter">
                        {loading ? (
                            <div className="text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <p className="mt-2 text-muted">Loading Quizzes...</p>
                            </div>
                        ) : quizzes.length === 0 ? (
                            <div className="text-center py-5">
                                <h5 className="text-muted">No quizzes available right now.</h5>
                            </div>
                        ) : (
                            quizzes.map((quiz) => (
                                <div className="col-lg-4 col-md-6 col-sm-12 mb-4" key={quiz.id}>
                                    <div className="case_boxed_wrapper bordered" style={{ border: '1px solid #dee2e6', height: '100%', display: 'flex', flexDirection: 'column' }}>
                                        
                                        <div className="case_boxed_img" style={{ position: 'relative' }}>
                                            <img src={process.env.REACT_APP_SERVER + quiz.image} alt={quiz.title} style={{ height: '220px', objectFit: 'cover', width: '100%' }} />
                                            <div style={{ position: 'absolute', top: '15px', left: '15px', background: 'rgba(0,0,0,0.8)', color: '#fff', padding: '5px 12px', borderRadius: '4px', fontSize: '13px', fontWeight: 'bold' }}>
                                                <i className="fa fa-clock-o me-1"></i> {formatQuizTime(quiz.quiz_time)}
                                            </div>
                                        </div>
                                        
                                        <div className="causes_boxed_text" style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', padding: '20px' }}>
                                            <h5 style={{ height: '50px', overflow: 'hidden', color: '#000', marginBottom: '10px' }}>
                                                {quiz.title}
                                            </h5>
                                            
                                            {/* Safely rendering HTML from the backend rich text editor */}
                                            <div 
                                                style={{ height: '70px', overflow: 'hidden', color: '#666', fontSize: '14px', marginBottom: '15px', textOverflow: 'ellipsis' }}
                                                dangerouslySetInnerHTML={{ __html: quiz.description }} 
                                            />
                                            
                                            <div className="d-flex justify-content-between align-items-center mb-3" style={{ fontSize: '14px', color: '#555', borderTop: '1px solid #eee', paddingTop: '15px' }}>
                                                <span><i className="fa fa-list-alt" style={{ color: 'var(--main-color)' }}></i> {quiz.total_questions} Questions</span>
                                            </div>
                                            
                                            <div className="mt-auto">
                                                <Link to={`/quiz/${generateSlug(quiz.title)}/${btoa(quiz.id.toString())}`} className="btn btn_theme btn_md w-100 py-2">
                                                    Start Quiz
                                                </Link>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </section>
        </>
    );
};

export default ExploreQuizzes;
